<div class="container">
  <mat-card>  
  <mat-card-header >
    <mat-card-title class="mat-card-info" (click)="deviceDisplayToggle=!deviceDisplayToggle"><a href="javascript:">Device Details</a></mat-card-title>
  </mat-card-header>
      <mat-card-content *ngIf="deviceDisplayToggle">      
        <div class="row">
            <table class="table" id="user-locations-table">
              <tbody>
                <tr>
                  <th>Device ID</th>
                  <th>Device Name</th>
                  <th>Status</th>
                  <th>Model</th>
                  <th>Property Name</th>
                  <th>Room Type</th>
                </tr>
                <tr *ngFor="let device of devices">
                   <td><a href [routerLink]="'/device-details/locationId/'+ device.location.id + '/device/' + device.id">{{device.id}}</a></td>
                  <td>{{capitalizeFirstLetter(device.label) }}</td>
                  <ng-container *ngIf="isNotSupportsDeviceStatus(device); else showStatus">
                    <td>NA</td>
                  </ng-container>
                  <ng-template #showStatus>
                    <td [ngClass]="{'status-active': device.status === 'ACTIVE', 'status-inactive': device.status !== 'ACTIVE'}">{{ device.status }}</td>
                  </ng-template>
                  <td>{{capitalizeFirstLetter(device.model)}}</td>
                  <td>{{ device.location.label }}</td>
                  <td>{{capitalizeFirstLetter(device.announcement)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      
    </mat-card-content>
    </mat-card>
  </div>
  
